import { render, staticRenderFns } from "./RoundButton.vue?vue&type=template&id=e164df7c&scoped=true"
import script from "./RoundButton.vue?vue&type=script&lang=js"
export * from "./RoundButton.vue?vue&type=script&lang=js"
import style0 from "./RoundButton.vue?vue&type=style&index=0&id=e164df7c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e164df7c",
  null
  
)

export default component.exports